import { ApplicationRootState } from 'redux-core/types';
import { createSelector, Selector } from 'reselect';
import { Currency } from 'api/Admin/Currency';
import { initialState } from './reducer';
import { CurrencyState } from './types';

export const selectAdminCurrency = (
    state: ApplicationRootState
): CurrencyState => state.admin.currency || initialState;

export const selectCurrencyList = createSelector(
    selectAdminCurrency,
    (state) => state.list
);

export const selectCurrency = (
    currencyId: number
): Selector<ApplicationRootState, Currency | null> =>
    createSelector(selectCurrencyList, (currencies): Currency | null => {
        return (
            currencies.data?.find((c: Currency) => c.id === currencyId) ?? null
        );
    });

export const selectCurrencyOptions = createSelector(
    selectCurrencyList,
    (currencies) => {
        return (
            currencies.data?.map((currency: Currency) => ({
                label: `${currency.symbol} - ${currency.name} (${currency.code})`,
                value: currency,
            })) ?? []
        );
    }
);

export const selectCurrenciesLoading = createSelector(
    selectAdminCurrency,
    (currencies): boolean => currencies.list.loading
);
